
export default function search(text, searchInput) {
    return text.toLowerCase().includes(searchInput.toLowerCase().trim());
}